"use client";

import { useState } from "react";
import FileUploader from "../../../components/common/FileUploader";

type Props = {
  setDoc: React.Dispatch<React.SetStateAction<any>>;
  className?: string;
};

const UploadModal = ({ setDoc, className }: Props) => {
  const [value, setValue] = useState<File | null>(null);

  return (
    <div className={`py-4 px-6 space-y-4 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px] ${className || "w-[600px]"}`}>
      <div className="overflow-y-auto space-y-4">
        <FileUploader
          name="photo"
          extraParentClasses="col-span-3"
          img="/img/upload-img.png"
          title="Upload Photo"
          message="Image should be in PNG or JPG format and less than 100 KB in size."
          classNameMain="bg-transparent border-none flex items-center gap-3"
          fileVal={value}
          setFileVal={(file: any) => {
            setValue(file); // ✅ local state (for preview)
            setDoc(file); // ✅ bubble up to parent
          }}
          accept="image/*"
          showPreview={true}
          required
        />
      </div>
    </div>
  );
};

export default UploadModal;
